import React from 'react';
import PropTypes, { any } from 'prop-types';
import Filter, { FilterModal, FilterSection } from './Filter';
import UtrFilterComponent from './FilterComponents/UtrFilterComponent';
import ButtonFilter from './FilterComponents/CoreComponents/ButtonFilter';
import RadioFilter from './FilterComponents/CoreComponents/RadioFilter';
import DropdownFilter from './FilterComponents/CoreComponents/DropdownFilter';
import { getUpdatedAgeTagsForPlayerSearch } from '../../../utils/search';

import styles from '../search.scss';

const PlayersMoreMobileFilter = (props) => {
    const { filterInputs, filters, handleFilterClick, filterModal, closeModals, handleFilterSubmit, clearFilters, playerFiltersAreActive, searchTypes, isPowerUser, userLoggedIn, handleFilterUpdate, mobileOnly, desktopOnly, 'data-testid': dataTestId } = props;

    const ageTags = searchTypes?.ageTags ? searchTypes.ageTags : [];
    const updatedAgeTags = getUpdatedAgeTagsForPlayerSearch(ageTags);
    const countries = searchTypes && searchTypes.countries ? searchTypes.countries : [];
    const divisions = searchTypes && searchTypes.divisions ? searchTypes.divisions : [];
    const conferences = searchTypes && searchTypes.conferences ? searchTypes.conferences : [];
    const colleges = searchTypes && searchTypes.colleges ? searchTypes.colleges : [];
    const tennisSportFilter = filters?.sportTypes?.tennis;
    const filterName = 'playersMoreMobile';

    return (
        <div className={styles.filterWrapper}>
            {userLoggedIn && (
                <Filter
                    filterName={filterName}
                    handleFilterClick={handleFilterClick}
                    isActive={playerFiltersAreActive || filterModal === filterName}
                    mobileOnly={mobileOnly}
                    desktopOnly={desktopOnly}
                    data-testid={dataTestId}
                >
                    More...
                </Filter>
            )}
            {filterModal === filterName && (
                <FilterModal
                    title={'More...'}
                    onCloseClick={closeModals}
                    clearFilters={() => clearFilters('playersMore', true)}
                    scrollable={true}
                    handleFilterSubmit={handleFilterSubmit}
                    data-testid={dataTestId}
                >
                    <FilterSection data-testid={dataTestId && `${dataTestId}.body`}>
                        <div className={styles.searchFilterModalTitle} data-testid={dataTestId && `${dataTestId}.gender-title`}>Gender</div>
                        <ButtonFilter
                            options={[
                                { label: 'All', value: '' },
                                { label: 'Male', value: 'M' },
                                { label: 'Female', value: 'F' },
                            ]}
                            selected={filterInputs.gender}
                            onClick={(gender) => {
                                handleFilterUpdate({ gender }, 'filterState');
                            }}
                            data-testid={dataTestId && `${dataTestId}.gender-options`}
                        />
                        <div className={styles.searchFilterModalDiv} />
                        <UtrFilterComponent
                            filterInputs={filterInputs}
                            filters={filters}
                            showExpandedUtrFilter={true}
                            handleUTRChange={(range) => {
                                handleFilterUpdate({
                                    utrMin: range[0],
                                    utrMax: range[1],
                                });
                            }}
                            handleUtrTypeClick={(utrType) => {
                                handleFilterUpdate({ utrType });
                            }}
                            handleUtrTeamTypeClick={(utrTeamType) => {
                                handleFilterUpdate({ utrTeamType });
                            }}
                            handleUtrReliabilityClick={(utrReliability) => {
                                handleFilterUpdate({ utrReliability });
                            }}
                            data-testid={dataTestId && `${dataTestId}.utr-filter`}
                        />
                        <div className={styles.searchFilterModalDiv} />
                        {isPowerUser ? (
                            <>
                                <div className={styles.searchFilterModalTitle} data-testid={dataTestId && `${dataTestId}.nationality-title`}>Nationality</div>
                                <DropdownFilter
                                    options={countries}
                                    selected={filterInputs.nationality}
                                    placeholder={'Any Country'}
                                    onChange={(nationality) => {
                                        handleFilterUpdate({ nationality });
                                    }}
                                    data-testid={dataTestId && `${dataTestId}.nationality-dropdown`}
                                />
                                <div className={styles.searchFilterModalDiv} />
                                {tennisSportFilter && (
                                    <>
                                        <div className={styles.searchFilterModalTitle} data-testid={dataTestId && `${dataTestId}.college-title`}>College</div>
                                        <DropdownFilter
                                            options={divisions}
                                            selected={filterInputs.division}
                                            placeholder={'Any Division'}
                                            onChange={(division) => {
                                                handleFilterUpdate({ division });
                                            }}
                                            data-testid={dataTestId && `${dataTestId}.division-dropdown`}
                                        />
                                        <div className={`mt16`}>
                                            <DropdownFilter
                                                options={conferences}
                                                selected={filterInputs.conference}
                                                placeholder={'Any Conference'}
                                                onChange={(conference) => {
                                                    handleFilterUpdate({ conference });
                                                }}
                                                data-testid={dataTestId && `${dataTestId}.conference-dropdown`}
                                            />
                                        </div>

                                        <div className={`mt16`}>
                                            <DropdownFilter
                                                options={colleges}
                                                selected={filterInputs.college}
                                                placeholder={'Any College'}
                                                onChange={(college) => {
                                                    handleFilterUpdate({ college });
                                                }}
                                                data-testid={dataTestId && `${dataTestId}.college-dropdown`}
                                            />
                                        </div>
                                    </>
                                )}
                            </>
                        ) : (
                            <FilterSection>
                                <div className="row">
                                    <div className="col">
                                        <p data-testid={dataTestId && `${dataTestId}.upgrade-message`}><button type="button" className="clickable text-teal" style={{ display: 'inline', border: 'none', background: 'none', padding: 0 }} onClick={() => props.handleUpgradeToPowerClick(filterName)} data-testid={dataTestId && `${dataTestId}.upgrade-to-power-btn`}>Upgrade to Power</button> to have access to nationality and college filters.</p>
                                    </div>
                                </div>
                            </FilterSection>
                        )}
                        <div className={styles.searchFilterModalDiv} />
                        <div className={styles.searchFilterModalTitle} data-testid={dataTestId && `${dataTestId}.age-division-title`}>Age Division</div>
                        <RadioFilter
                            name="ageTag"
                            options={updatedAgeTags}
                            selected={filterInputs.ageTag}
                            onChange={(ageTag) => {
                                handleFilterUpdate({ ageTag });
                            }}
                            data-testid={dataTestId && `${dataTestId}.age-tag-options`}
                        />
                    </FilterSection>
                </FilterModal>
            )}
        </div>
    );
};

PlayersMoreMobileFilter.propTypes = {
    filters: PropTypes.instanceOf(Object),
    mobileOnly: PropTypes.bool,
    desktopOnly: PropTypes.bool,
    handleFilterUpdate: PropTypes.func,
    userLoggedIn: PropTypes.bool,
    isPowerUser: PropTypes.bool,
    searchTypes: PropTypes.arrayOf(any).isRequired,
    playerFiltersAreActive: PropTypes.bool,
    clearFilters: PropTypes.func,
    handleFilterSubmit: PropTypes.func,
    closeModals: PropTypes.func,
    filterModal: PropTypes.string.isRequired,
    handleFilterClick: PropTypes.func,
    filterInputs: PropTypes.objectOf(any).isRequired,
    handleUpgradeToPowerClick: PropTypes.func.isRequired,
    'data-testid': PropTypes.string,
};

PlayersMoreMobileFilter.defaultProps = {
    filters: {},
    mobileOnly: false,
    desktopOnly: false,
    handleFilterUpdate: () => { },
    userLoggedIn: false,
    isPowerUser: false,
    playerFiltersAreActive: false,
    clearFilters: () => { },
    handleFilterSubmit: () => { },
    closeModals: () => { },
    handleFilterClick: () => { },
    'data-testid': undefined,
};

export default PlayersMoreMobileFilter;
